import React, { useMemo, useState } from 'react';
import { useUrlFriendlyToParameters, useNavigateTo } from 'helpers/urlFriendly';
import PageHeader from 'components/common/PageHeader';



export default function Entries() {
    const { mirs_competition, mirs_language, mirs_discipline, mirs_noc } = useUrlFriendlyToParameters()
    const params = useUrlFriendlyToParameters()

    return (
        <>
            <PageHeader title='Entries' />
            <div>To do</div>
        </>
    )
};